import React from 'react'
import PropTypes from 'prop-types'
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Grid } from '@material-ui/core'
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline'
import WarningIcon from '@material-ui/icons/Warning'
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline'
import { CustomButton } from 'components/CustomButton'

export const ModalAlerta = (props) => {
  const {
    aberto,
    onClose,
    titulo = 'ATENÇÃO',
    mensagens = [],
    tipo = 'erro',
    children,
  } = props

  const getIcone = () => {
    switch (tipo) {
      case 'aviso':
        return <WarningIcon style={{ color: '#FF9800' }} />
      case 'sucesso':
        return <CheckCircleOutlineIcon style={{ color: '#4CAF50' }} />
      case 'erro':
      default:
        return <ErrorOutlineIcon color="error" />
    }
  }

  const getCorBotao = () => {
    switch (tipo) {
      case 'aviso':
        return 'warning'
      case 'sucesso':
        return 'success'
      case 'erro':
      default:
        return 'error'
    }
  }

  return (
    <Dialog open={aberto} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle disableTypography style={{ padding: '20px 24px 10px 24px' }}>
        <b>{titulo.toUpperCase()}</b>
      </DialogTitle>
      <DialogContent style={{ padding: '10px 24px' }}>
        {children ? (
          children
        ) : (
          mensagens.map((mensagem, idx) => (
            <DialogContentText key={idx} style={{ marginBottom: '12px' }}>
              <Grid container spacing={2} alignItems="center" wrap="nowrap">
                <Grid item style={{ display: 'flex', alignItems: 'center' }}>
                  {getIcone()}
                </Grid>
                <Grid item xs={11} style={{ color: tipo === 'erro' ? '#E53935' : 'inherit' }}>
                  {mensagem}
                </Grid>
              </Grid>
            </DialogContentText>
          ))
        )}
      </DialogContent>
      <DialogActions style={{ padding: '20px 24px' }}>
        <CustomButton onClick={onClose} colorType={getCorBotao()} variant="contained" fullWidth>
          Fechar
        </CustomButton>
      </DialogActions>
    </Dialog>
  )
}

ModalAlerta.propTypes = {
  aberto: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  titulo: PropTypes.string,
  mensagens: PropTypes.arrayOf(PropTypes.string),
  tipo: PropTypes.oneOf(['erro', 'aviso', 'sucesso']),
  children: PropTypes.node,
}
